export default {
  menu: 'Company Theme Management',
  label: {
    theme: 'Customize Company Theme',
    name: 'Name',
    link: 'URL',
    headerSetting: 'Header Setting',
    footerSetting: 'Footer Setting',
    commonSetting: 'General Setting',
    personalHomePCSetting: 'Candidate Homepage Setting (PC)',
    personalHomeMobileSetting: 'Candidate Homepage Setting (Mobile)',
    loginSetting: 'Login Page Setting',
    companyDetailSetting: 'Navigation Setting',
    showCompanyLogo: 'Customize the Header Logo',
    logoImage: 'Logo',
    faviconImage: 'Browser Tab Logo',
    customColor: 'Theme Color',
    logoPosition: 'Align to',
    showCompanyName: 'Display Company Name',
    logoWidth: 'Logo Width',
    backgroundColor: 'Background Color',
    fontColor: 'Font Color',
    phoneIcon: 'Show AJINGA 400 service number',
    userMenu: 'User menu setting',
    height: 'Header Height',
    content: 'Navigations',
    customFont: 'Font',
    navigationLinkPosition: 'Navigation bar position',
    userMenuBackgroundColor: 'Background Color',
    userMenuFontColor: 'Font Color',
    pageBackgroundColor: 'Background Color',
    showContainerLogo: 'Display Company Logo',
    followCustomColor: 'Use Theme Color',
    customMenuList: 'Menu Setting',
    languagePosition: 'Language Toggle on',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    homePage: 'Home Page',
    infoPage: 'Info Page',
    jobListPage: 'Job List Page',
    menuGroupName: 'Menu Title',
    onlyEmployee: 'onlyEmployee',
    bindOrChangeMobile: 'Bind Mobile/Change Mobile',
    bindOrChangeEmail: 'Bind Email/Change Email',
    fixedHeader: 'Floating Header',
    enName: 'Title (EN)',
    cnName: 'Title (CN)'
  },
  btn: {
    addNewLine: 'Add New Raw',
    reuploadFont: 'Reupload',
    uploadFont: 'Upload Font'
  },
  message: {
    fieldIsRequired: 'This field in required.'
  }
}
